import { pdfjs } from 'react-pdf/dist/esm/entry.webpack';

async function getFileMetadata(
  src: string | File
): Promise<{ width: number; height: number; num_pages: number } | undefined> {
  const isFile = src instanceof File;
  let url: string | undefined;
  try {
    url = isFile ? URL.createObjectURL(src) : src;
    const pdfDocument = await pdfjs.getDocument(url).promise;
    if (pdfDocument.numPages <= 0) {
      throw new Error('PDF is empty');
    }
    const page = await pdfDocument.getPage(1);
    const [, , width, height] = page.view;
    return { width: Math.floor(width), height: Math.floor(height), num_pages: pdfDocument.numPages };
  } finally {
    if (url && isFile) URL.revokeObjectURL(url);
  }
}

export { getFileMetadata };
